import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";
import SellerSidebar from "./common/SellerSidebar";
import Swal from "sweetalert2";

const data = [
  { date: "12 May", sales: 2 },
  { date: "13 May", sales: 3 },
  { date: "14 May", sales: 5 },
  { date: "15 May", sales: 3.5 },
  { date: "16 May", sales: 4 },
  { date: "17 May", sales: 2 },
  { date: "18 May", sales: 2.5 },
];

const AdminDashboard = () => {
  const navigate = useNavigate();

  const [orders, setOrders] = useState([
    {
      id: 1,
      event: "fund collection for flood .....",
      date: "Aug, 28 2024 ",
      goal: "2,000,000,000",
      raised: "0",
      time: "02:00PM - 05:00PM",
      location: "Singapore",
      eventType: "Private",
      attendees: "35",
      action: "Confirmed",
    },
    {
      id: 2,
      event: "fund collection for flood .....",
      date: "Aug, 28 2024 ",
      goal: "2,000,000,000",
      raised: "0",
      time: "02:00PM - 05:00PM",
      location: "Singapore",
      eventType: "Private",
      attendees: "35",
      action: "Confirmed",
    },
    {
      id: 3,
      event: "fund collection for flood .....",
      date: "Aug, 28 2024 ",
      goal: "2,000,000,000",
      raised: "0",
      time: "02:00PM - 05:00PM",
      location: "Singapore",
      eventType: "Public",
      attendees: "35",
      action: "Confirmed",
    },
    {
      id: 4,
      event: "fund collection for flood .....",
      date: "Aug, 28 2024 ",
      goal: "2,000,000,000",
      raised: "0",
      time: "02:00PM - 05:00PM",
      location: "Singapore",
      eventType: "Public",
      attendees: "35",
      action: "Confirmed",
    },
    {
      id: 5,
      event: "fund collection for flood .....",
      date: "Aug, 28 2024 ",
      goal: "2,000,000,000",
      raised: "0",
      time: "02:00PM - 05:00PM",
      location: "Singapore",
      eventType: "Private",
      attendees: "35",
      action: "Confirmed",
    },
    {
      id: 6,
      event: "fund collection for flood .....",
      date: "Aug, 28 2024 ",
      goal: "2,000,000,000",
      raised: "0",
      time: "02:00PM - 05:00PM",
      location: "Singapore",
      eventType: "Public",
      attendees: "35",
      action: "Confirmed",
    },
  ]);

  // Hooks for table functionality
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [filterStatus, setFilterStatus] = useState("all");
  const [userDetail, setUserDetail] = useState({});

  // Sorting function
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Filter orders based on status
  const filteredOrders = orders.filter((order) => {
    if (filterStatus === "all") return true;
    return order.status.toLowerCase() === filterStatus.toLowerCase();
  });

  // Sort orders
  const sortedOrders = [...filteredOrders].sort((a, b) => {
    if (sortConfig.key) {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === "asc" ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === "asc" ? 1 : -1;
      }
    }
    return 0;
  });

  // Limit to 8 orders for display
  const currentOrders = sortedOrders.slice(0, 8);

  // View All functionality
  const handleViewAll = () => {
    // You can replace this with your actual orders page route
    // window.location.href = "/orders"; // or use React Router: navigate('/orders')
  };
  const handleRegisterClick = () => {
    if (userDetail.userTypeLabel === "owner") {
      navigate("/register-your-business");
    } else {
      Swal.fire({
        icon: "error",
        title: "Owner Restrcition",
        text: "Only owner can register business",
      });
    }
    // setBusinessStatus("pending");
  };
  // Get total orders count
  const totalOrders = orders.length;

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    setUserDetail(userData);
  }, []);
  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea profiles">
          <div className="container">
            <div className="bradcams">
              <span className="bothss">
                <Link to="">Dashboard</Link>{" "}
              </span>
            </div>
            <div className="row">
              <div className="col-lg-3 mb_view_hide">
                <SellerSidebar />
              </div>

              {/* Dashboard Details*/}
              <div className="col-lg-9">
                <div
                  className="d-flex justify-content-between align-items-center mb-3"
                  style={{ gap: "12px" }}
                >
                  <h4 style={{ fontWeight: "600" }}>Dashboard</h4>
                  {/* Left: Search + Filter */}
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "8px" }}
                  >
                    <div
                      className=""
                      style={{ position: "relative", width: "200px" }}
                    >
                      <button
                        className="btn-access"
                        onClick={handleRegisterClick}
                      >
                        Register Your Business
                      </button>
                    </div>
                    {/* <button className="btn-filter">
                      <img src="/images/controls-alt.png" alt="filter" />
                    </button> */}
                  </div>
                </div>
                <div className="form_boxx profilss ">
                  {/* Cards */}
                  <div className="form_boxx Impact">
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="im_pects_box">
                          <div className="ic_arae">
                            <img src="/images/wallet_s_im.png" alt="" />
                          </div>
                          <div className="im_tc_texs">
                            <p>Total Campaigns</p>
                            <h6>250</h6>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="im_pects_box">
                          <div className="ic_arae">
                            <img src="/images/wallet_s_im.png" alt="" />
                          </div>
                          <div className="im_tc_texs">
                            <p>Total Events</p>
                            <h6>156 </h6>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="im_pects_box">
                          <div className="ic_arae">
                            <img src="/images/calender_im.png" alt="" />
                          </div>
                          <div className="im_tc_texs">
                            <p>Total Employees</p>
                            <h6>9</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Chart */}
                  <div className="form_arar mt-4 ">
                    <div className="chart-card">
                      <div className="chart-header d-flex justify-content-between">
                        <h3 className="chart-title">Campaigns Success</h3>

                        <div className="chart-actions">
                          <select
                            className="chart-select"
                            defaultValue="Monthly"
                          >
                            <option>Monthly</option>
                            <option>Quarterly</option>
                            <option>Yearly</option>
                          </select>
                          {/* Optional icons: */}
                          <button
                            className="chart-icon-btn"
                            aria-label="Download"
                          >
                            <img src="svg/download.svg" alt="download" />
                          </button>
                          <button className="chart-icon-btn" aria-label="More">
                            ⋮
                          </button>
                        </div>
                      </div>

                      <div className="chart-body ">
                        <ResponsiveContainer width="100%" height={260}>
                          <BarChart
                            data={data}
                            margin={{
                              top: 10,
                              right: 20,
                              bottom: 10,
                              left: 20,
                            }}
                            barCategoryGap={12}
                          >
                            <CartesianGrid stroke="#e9ecef" vertical={false} />
                            <XAxis
                              dataKey="date"
                              tick={{ fill: "#6c757d", fontSize: 6 }}
                              tickLine={false}
                              axisLine={{ stroke: "#e9ecef" }}
                            />
                            <YAxis
                              domain={[0, 5]}
                              ticks={[0, 1, 2, 3, 4, 5]}
                              tick={{ fill: "#6c757d", fontSize: 14 }}
                              tickLine={false}
                              axisLine={{ stroke: "#e9ecef" }}
                              label={{
                                value: "No. of hours",
                                angle: -90,
                                position: "insideLeft",
                                offset: 10,
                                style: { fill: "#495057", fontWeight: 600 },
                              }}
                            />
                            <Tooltip
                              cursor={{ fill: "rgba(0,0,0,0.03)" }}
                              contentStyle={{
                                borderRadius: 8,
                                border: "1px solid #e9ecef",
                                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                              }}
                            />
                            <Bar
                              dataKey="sales"
                              fill="#4AA5A5"
                              radius={[8, 8, 0, 0]}
                              maxBarSize={28}
                            />
                          </BarChart>
                        </ResponsiveContainer>

                        <div className="x-axis-title">Weekly dates</div>
                      </div>
                    </div>
                  </div>

                  {/* Recent orders List */}
                  <div className="form_arar mt-4">
                    <div className="d-flex justify-content-between items-center mb-4">
                      <h5 className="recent-orders-title">Recent Campaigns</h5>
                      <button className="view-all-link" onClick={handleViewAll}>
                        View All
                      </button>
                    </div>

                    <div className="orders-table-container">
                      <table className="orders-table">
                        <thead>
                          <tr className="table-header">
                            <th className="header-cell">S. No.</th>
                            <th className="header-cell">Event Name</th>
                            <th className="header-cell">Featured</th>
                            <th className="header-cell">Goal</th>
                            <th className="header-cell">Raised</th>
                            <th className="header-cell">Created At</th>
                            <th className="header-cell">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentOrders.map((order, index) => (
                            <tr key={order.id} className="table-row">
                              <td className="table-cell serial-number">
                                {index + 1}.
                              </td>
                              <td className="table-cell product-name">
                                {order.event}
                              </td>
                              <td className="table-cell product-name">
                                {order.date}
                              </td>
                              <td className="table-cell product-name">
                                ${order.goal}
                              </td>
                              <td className="table-cell product-name">
                                ${order.raised}
                              </td>
                              <td className="table-cell product-name">
                                {order.date}
                              </td>
                              <td className="table-cell action">
                                <div className="flexx" style={{ gap: "10px" }}>
                                  <img
                                    className="action-btn edit-btn"
                                    src="/images/edit_views.png"
                                    alt="edit"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEdit(order.id)}
                                  />
                                  <img
                                    className="action-btn delete-btn"
                                    src="/images/ic_delets.png"
                                    alt="delete"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDelete(order.id)}
                                  />
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="form_arar mt-4">
                    <div className="d-flex justify-content-between items-center mb-4">
                      <h5 className="recent-orders-title">Recent Events</h5>
                      <button className="view-all-link" onClick={handleViewAll}>
                        View All
                      </button>
                    </div>

                    <div className="orders-table-container">
                      <table className="orders-table">
                        <thead>
                          <tr className="table-header">
                            <th className="header-cell">S. No.</th>
                            <th className="header-cell">Event Name</th>
                            <th className="header-cell">Date</th>
                            <th className="header-cell">Time</th>
                            <th className="header-cell">Location</th>
                            <th className="header-cell">Event Type</th>
                            <th className="header-cell">Attendees</th>
                            <th className="header-cell">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentOrders.map((order, index) => (
                            <tr key={order.id} className="table-row">
                              <td className="table-cell serial-number">
                                {index + 1}.
                              </td>
                              <td className="table-cell product-name">
                                {order.event}
                              </td>
                              <td className="table-cell product-name">
                                {order.date}
                              </td>
                              <td className="table-cell product-name">
                                {order.time}
                              </td>
                              <td className="table-cell product-name">
                                {order.location}
                              </td>
                              <td className="table-cell product-name">
                                {order.eventType}
                              </td>
                              <td className="table-cell product-name">
                                {order.attendees}
                              </td>
                              <td className="table-cell action">
                                <div className="flexx" style={{ gap: "10px" }}>
                                  <img
                                    className="action-btn edit-btn"
                                    src="/images/edit_views.png"
                                    alt="edit"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEdit(order.id)}
                                  />
                                  <img
                                    className="action-btn delete-btn"
                                    src="/images/ic_delets.png"
                                    alt="delete"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDelete(order.id)}
                                  />
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Bulk Products */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdminDashboard;
